<div>
    <header class="flex flex-row items-center justify-between w-full shadow-md bg-white px-4 py-4 mb-4">
        <div class="flex flex-row gap-2 w-auto">
            <button 
                type="button"
                class="flex items-center uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2 text-white rounded-lg shadow-md transition duration-300"
                appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                matTooltip
                (click)="addCategoryForm()"
            >
                Add
            </button>
            <button 
                type="button"
                class="flex items-center uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2 text-white rounded-lg shadow-md transition duration-300"
                [disabled]="categoryForms.length === 0"
                [ngClass]="{'opacity-50 cursor-not-allowed': categoryForms.length === 0}"
                appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                matTooltip
                (click)="saveCategoryInBulk()"
            >
                Save All ({{ categoryForms.length }})
            </button>
        </div>
        <div class="flex flex-row items-center gap-2 w-auto">
            <app-search-control
                [searchPlaceholder]="'Search categories'"
                (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
                (keydownEvent)="keyDownFunction($event)">
            </app-search-control>
            <button 
                type="button"
                [ngClass]="'violet-text'"
                class="material-icons flex items-center custom-btn btn-dark-orange px-4 py-1"
                (click)="closeDialog()"
            >
               close
            </button>
        </div>
    </header>
    <div class="scrollable-container w-full">
        <app-data-table
            [tableHeader]="tableHeader"
            [tableSubHeader]="tableSubHeader"
            [isLoading]="isLoading"
            [sort_type]="sort_type"
            (toggleOnSort)="sortList($event.key, $event.type)"
        >
            <!-- DISPLAY EXISTING CATEGORIES -->
            <tr class="focus:outline-none" *ngFor="let category of category_list" [ngClass]="{'bg-white': isEditing(category.uid)}">
                <!-- UID -->
                <td>{{ category.uid | nullWithDefault }}</td>
                
                <!-- Item Category -->
                <td>
                    <ng-container *ngIf="isEditing(category.uid); else viewCategory">
                        <div class="card-input flex flex-col text-xs py-1 w-full" [appHighlightOnActive]>
                            <div class="flex items-center justify-between bg-gray-100 rounded-md">
                                <input
                                    [(ngModel)]="category.itemCategory"
                                    class="w-full h-20-px bg-gray-100 rounded-md pl-3 focus:outline-none cursor-not-allowed"
                                    type="text"
                                    placeholder="Category Name*"
                                    [readonly]="true"
                                />
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #viewCategory>
                        <div class="flex items-center justify-between rounded-md">
                            {{ category.itemCategory | nullWithDefault }}
                        </div>
                    </ng-template>
                </td>
                
                <!-- Category Description -->
                <td>
                    <ng-container *ngIf="isEditing(category.uid); else viewDescription">
                        <div class="card-input flex flex-col text-xs py-1 w-full" [appHighlightOnActive]>
                            <div class="flex items-center justify-between bg-gray-100 rounded-md">
                                <input
                                    [(ngModel)]="category.categoryDescription"
                                    class="w-full h-20-px bg-gray-100 rounded-md pl-3 focus:outline-none"
                                    type="text"
                                    placeholder="Description*"
                                />
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #viewDescription>
                        <div class="flex items-center justify-between rounded-md">
                            {{ category.categoryDescription | nullWithDefault }}
                        </div>
                    </ng-template>
                </td>
                
                <!-- Image URL -->
                <td>
                    <div *ngIf="isEditing(category.uid); else viewImage" class="card-input flex flex-col text-xs py-1 w-full" [appHighlightOnActive]="">
                        <div class="flex items-center justify-between bg-gray-100 rounded-md">
                            <input 
                                #existingImageInput 
                                type="file" 
                                style="display: none;" 
                                accept="image/*"
                                (change)="onExistingCategoryFileSelected($event, category, 'image')"
                            >
                            <span 
                                class="text-xs truncate max-w-[150px]" 
                                [title]="category.newImageFileName || category.imageUrl"
                            >
                                {{ truncateFilename(category.newImageFileName || category.imageUrl, 25) }}
                            </span>
                            <button 
                                type="button"
                                class="custom-btn login-bg text-xs px-3 py-1 whitespace-nowrap"
                                (click)="existingImageInput.click()"
                            >
                                Change
                            </button>
                        </div>
                    </div>
                    <ng-template #viewImage>
                        <span 
                            class="text-xs truncate block max-w-[200px]"
                            [title]="category.imageUrl"
                        >
                            {{ truncateFilename(category.imageUrl, 30) }}
                        </span>
                    </ng-template>
                </td>

                <!-- Image Banner URL-->
                <td>
                    <div *ngIf="isEditing(category.uid); else viewBanner" class="card-input flex flex-col text-xs py-1 w-full" [appHighlightOnActive]="">
                        <div class="flex items-center justify-between bg-gray-100 rounded-md">
                            <input 
                                #existingBannerInput 
                                type="file" 
                                style="display: none;" 
                                accept="image/*"
                                (change)="onExistingCategoryFileSelected($event, category, 'imageBanner')"
                            >
                            <span 
                                class="text-xs truncate max-w-[150px]"
                                [title]="category.newImageBannerFileName || category.imageBannerUrl"
                            >
                                {{ truncateFilename(category.newImageBannerFileName || category.imageBannerUrl, 35) }}
                            </span>
                            <button 
                                type="button"
                                class="custom-btn login-bg text-xs px-3 py-1 whitespace-nowrap"
                                (click)="existingBannerInput.click()"
                            >
                                Change
                            </button>
                        </div>
                    </div>
                    <ng-template #viewBanner>
                        <span 
                            class="text-xs truncate block max-w-[200px]"
                            [title]="category.imageBannerUrl"
                        >
                            {{ truncateFilename(category.imageBannerUrl, 35) }}
                        </span>
                    </ng-template>
                </td>

                <!-- Date Created -->
                <td class="text-xs">
                    <span [title]="category.createDate">
                        {{ category.createDate | date:'yyyy-MM-dd' | nullWithDefault }}
                    </span>
                </td>

                <!-- Created By -->
                <td class="text-xs">
                    {{ category.createUser | nullWithDefault }}
                </td>
                
                <!-- TABLE ACTIONS -->
                <td class="text-xs">
                    <div class="flex items-center justify-center space-x-3">
                        <!-- Edit Mode Actions -->
                        <ng-container *ngIf="isEditing(category.uid)">
                            <button 
                                type="button"
                                class="power-btn2 custom-btn"
                                (click)="cancelEdit(category)"
                            >
                                Cancel
                            </button>
                            <button 
                                type="button"
                                class="power-btn2 active custom-btn"
                                (click)="updateCategory(category)"
                                appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                                matTooltip
                            >
                                Save
                            </button>
                        </ng-container>
                        
                        <!-- View Mode Actions -->
                        <app-toggleable-button
                            *ngIf="!isEditing(category.uid)"
                            [isEnabled]="isCategoryEnabled(category)"
                            [isLoading]="loadingCategories.has(category.uid)"
                            [enabledClass]="'power-btn2 active custom-btn'"
                            [disabledClass]="'power-btn2 custom-btn'"
                            [baseClass]="'text-xs'"
                            [enabledLabel]="'Disabled'"
                            [disabledLabel]="'Enabled'"
                            [showIcons]="false"
                            (toggleState)="toggleCategoryStatus(category, $event)"
                            appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                            matTooltip
                        >
                        </app-toggleable-button>
                        <button 
                            *ngIf="!isEditing(category.uid)"
                            type="button"
                            class="action-btn-blue2 custom-btn"
                            (click)="editCategory(category)"
                            appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                            matTooltip
                        >
                            Edit
                        </button>
                    </div>
                </td>
            </tr>
            
            <!-- GENERATE INPUT FORM TO ADD NEW CATEGORIES -->
            <ng-container *ngIf="categoryForms.length > 0" [formGroup]="newCategoriesForm">
                <ng-container formArrayName="categories">
                    <tr *ngFor="let formGroup of categoryFormsArray; let i = index" 
                        [formGroupName]="i" 
                        class="border-2 bg-white"
                        [ngClass]="{'opacity-50': isRowSaving(i)}"
                    >
                        <td class="flex flex-row items-center justify-center gap-2 px-2 py-2">
                            <span class="material-icons flex items-center justify-center text-white login-bg rounded-full">
                                {{ isRowSaving(i) ? 'hourglass_empty' : 'add' }}
                            </span>
                            <span class="text-sm orange-text">New</span>
                        </td>
                        
                        <!-- Item Category -->
                        <td>
                            <div class="card-input flex flex-col text-sm py-1 w-full" [appHighlightOnActive]="">
                                <input
                                    formControlName="itemCategory"
                                    [readonly]="isRowSaving(i)"
                                    [ngClass]="getValidationError(i, 'itemCategory') ? 'placeholder-red-700' : 'placeholder-gray-500'"
                                    class="focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                                    type="text"
                                    [placeholder]="
                                        getValidationError(i, 'itemCategory')
                                        ? getValidationError(i, 'itemCategory')
                                        : 'Category Name*'
                                    "
                                />
                            </div>
                        </td>
                        
                        <!-- Category Description -->
                        <td>
                            <div class="card-input flex flex-col text-sm py-1 w-full" [appHighlightOnActive]="">
                                <input 
                                    formControlName="categoryDescription"
                                    [readonly]="isRowSaving(i)"
                                    [ngClass]="getValidationError(i, 'categoryDescription') ? 'placeholder-red-700' : 'placeholder-gray-500'"
                                    class="placeholder-gray-500 focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                                    type="text" 
                                    [placeholder]="
                                        getValidationError(i, 'categoryDescription')
                                        ? getValidationError(i, 'categoryDescription')
                                        : 'Description*'
                                    "
                                >
                            </div>
                        </td>
                        
                        <!-- Image -->
                        <td>
                            <div class="card-input flex flex-col text-xs py-1 w-full" [appHighlightOnActive]="">
                                <div class="flex items-center justify-between bg-gray-100 rounded-md">
                                    <input 
                                        #imageInput 
                                        type="file" 
                                        style="display: none;" 
                                        class="text-sm"
                                        accept="image/*" 
                                        [disabled]="isRowSaving(i)"
                                        (change)="onFileSelected($event, 'image', i)"
                                    >
                                    <div class="flex items-center flex-1 min-w-0 px-3">
                                        <span class="italic truncate" *ngIf="getFileName(i, 'image'); else imagePlaceholder">
                                            {{ getFileName(i, 'image') }}
                                        </span>
                                        <ng-template #imagePlaceholder>
                                            <div class="flex flex-col text-xs">
                                                <span class="italic text-gray-500">Image Size: 551x360*</span>
                                                <span class="italic text-gray-500">File Size: 500kb*</span>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <button 
                                        type="button"
                                        class="uppercase custom-btn login-bg font-semibold text-xs px-6 py-1.5"
                                        [disabled]="isRowSaving(i)"
                                        (click)="imageInput.click()"
                                    >
                                        Upload
                                    </button>
                                </div>
                                <span class="text-red-500 text-xs mt-1" *ngIf="getValidationError(i, 'image')">
                                    {{ getValidationError(i, 'image') }}
                                </span>
                            </div>
                        </td>
                        
                        <!-- Image Banner -->
                        <td>
                            <div class="card-input flex flex-col text-xs py-1 w-full" [appHighlightOnActive]="">
                                <div class="flex items-center justify-between bg-gray-100 rounded-md">
                                    <input 
                                        #imageBannerInput 
                                        type="file" 
                                        style="display: none;" 
                                        class="text-sm"
                                        accept="image/*"
                                        [disabled]="isRowSaving(i)"
                                        (change)="onFileSelected($event, 'imageBanner', i)"
                                    >
                                    <div class="flex items-center flex-1 min-w-0 px-3">
                                        <span class="italic truncate" *ngIf="getFileName(i, 'imageBanner'); else bannerPlaceholder">
                                            {{ getFileName(i, 'imageBanner') }}
                                        </span>
                                        <ng-template #bannerPlaceholder>
                                            <div class="flex flex-col text-xs">
                                                <span class="italic text-gray-500">Image Size: 573x377*</span>
                                                <span class="italic text-gray-500">File Size: 500kb*</span>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <button 
                                        type="button"
                                        class="uppercase custom-btn login-bg font-semibold text-xs px-6 py-1.5"
                                        [disabled]="isRowSaving(i)"
                                        (click)="imageBannerInput.click()"
                                    >
                                        Upload
                                    </button>
                                </div>
                                <span class="text-red-500 text-xs mt-1" *ngIf="getValidationError(i, 'imageBanner')">
                                    {{ getValidationError(i, 'imageBanner') }}
                                </span>
                            </div>
                        </td>

                        <!-- just to fill the gap during add (empty for new entries) -->
                        <td class="text-xs text-center bg-transparent italic">
                        </td>

                        <!--  just to fill the gap during add (empty for new entries) -->
                        <td class="text-xs text-center bg-transparent italic">
                        </td>
                        
                        <!-- Actions -->
                        <td class="text-xs">
                            <div class="flex items-center justify-center space-x-3">
                                <button 
                                    type="button"
                                    class="power-btn2 custom-btn"
                                    [disabled]="isRowSaving(i)"
                                    (click)="removeCategoryForm(i)"
                                    title="Remove this row"
                                >
                                    Remove
                                </button>
                                <button 
                                    appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                                    matTooltip
                                    type="button"
                                    (click)="saveCategory(i)"
                                    class="power-btn2 active custom-btn"
                                    [disabled]="categoryFormsArray[i].invalid || isRowSaving(i)"
                                    [ngClass]="{'opacity-50 cursor-not-allowed': categoryFormsArray[i].invalid || isRowSaving(i)}"
                                    title="Save this category"
                                >
                                    {{ isRowSaving(i) ? 'Saving...' : 'Save' }}
                                </button>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
        </app-data-table>
        
        <div class="w-full items-center justify-between">
            <app-pagination
                [currentPage]="current_page"
                [totalPages]="total_pages"
                [pageSize]="size"
                [totalItems]="total"
                (pageChange)="setPage($event)"
                (previousPage)="prevPage()"
                (nextPage)="nextPage()"
                [showTotalEntries]="false"
            >
                <app-limit-control
                    [currentLimit]="size"
                    (limitChangeEvent)="onLimitChangeFromComponent($event)">
                </app-limit-control> 
            </app-pagination>
        </div>
    </div>
</div>